/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/customer_display';
import '../common/store_and_forward';
import '../common/tipping';
import '../common/signature';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "terminal": {
                            "nested": {
                              "TerminalAPISettings": {
                                "fields": {
                                  "idleScreenSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.CustomerDisplay",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "securitySettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.terminal.TerminalAPISettings.SecuritySettings",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "standaloneSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.terminal.TerminalAPISettings.StandaloneSettings",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "SecuritySettings": {
                                    "fields": {
                                      "enablePasscode": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      }
                                    }
                                  },
                                  "StandaloneSettings": {
                                    "fields": {
                                      "storeAndForward": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "tipping": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "signature": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "enableStandaloneMode": {
                                        "type": "bool",
                                        "id": 4,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.terminal?.nested?.TerminalAPISettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.terminal?.nested?.TerminalAPISettings?.nested?.SecuritySettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.terminal?.nested?.TerminalAPISettings?.nested?.StandaloneSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE TerminalAPISettings @ squareup/devicesettings/profiles/v2/model/settings/terminal/terminal_api_settings.proto at 23:1
 */
export const TerminalAPISettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.terminal.TerminalAPISettings');
fixType(TerminalAPISettings);
Builder.createAndAttachToType(TerminalAPISettings);
/**
 * SOURCE SecuritySettings @ squareup/devicesettings/profiles/v2/model/settings/terminal/terminal_api_settings.proto at 43:3
 */
TerminalAPISettings.SecuritySettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.terminal.TerminalAPISettings.SecuritySettings');
fixType(TerminalAPISettings.SecuritySettings);
Builder.createAndAttachToType(TerminalAPISettings.SecuritySettings);
/**
 * SOURCE StandaloneSettings @ squareup/devicesettings/profiles/v2/model/settings/terminal/terminal_api_settings.proto at 52:3
 */
TerminalAPISettings.StandaloneSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.terminal.TerminalAPISettings.StandaloneSettings');
fixType(TerminalAPISettings.StandaloneSettings);
Builder.createAndAttachToType(TerminalAPISettings.StandaloneSettings);